import { Injectable } from '@angular/core';

import { HubService } from '@app/core/hubs/hub.service';
import { NotificationAlert } from '@app/pages/notifications/models/notification.model';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class NotificationsHubService extends HubService<NotificationAlert> {
  constructor() {
    super();
  }

  override initHub(): void {
    super.initHub(`${environment.notificationSignalrApi}`);
  }

  addDataListener(): void {
    this.hubConnection.on('OnMessageReceived', (data: NotificationAlert) => {
      this.streamReceivedData.emit(data);
    });
  }
}
